module.exports = __webpack_public_path__ + "img/profile-teodora.4f36ffbe.png";